import { render, staticRenderFns } from "./instagramStoriesCard.vue?vue&type=template&id=2bbb3265&scoped=true&lang=html&"
import script from "./instagramStoriesCard.vue?vue&type=script&lang=js&"
export * from "./instagramStoriesCard.vue?vue&type=script&lang=js&"
import style0 from "./instagramStoriesCard.vue?vue&type=style&index=0&id=2bbb3265&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb3265",
  null
  
)

export default component.exports